import { render, staticRenderFns } from "./addQuestion.vue?vue&type=template&id=60db97dc&scoped=true&"
import script from "./addQuestion.vue?vue&type=script&lang=js&"
export * from "./addQuestion.vue?vue&type=script&lang=js&"
import style0 from "./addQuestion.vue?vue&type=style&index=0&id=60db97dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60db97dc",
  null
  
)

export default component.exports